export const AUTO_PULL_SEC_MIN = 1.5;
export const AUTO_PULL_SEC_MAX = 2;
export const getAutoPullDelayMs = () => {
    const span = AUTO_PULL_SEC_MAX - AUTO_PULL_SEC_MIN;
    const sec = AUTO_PULL_SEC_MIN + Math.random() * span;
    return Math.round(sec * 1e3);
};
export const getAutoPullIntervalHint = () => `${AUTO_PULL_SEC_MIN}\uFF5E${AUTO_PULL_SEC_MAX} \u79D2`;
export const sleepMs = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
